import Loader from '@hotmart/space-lib/dist/components/loader'
import clsx from 'clsx'

import type { LoadingStateProps } from './types'

const LoadingState = ({ className = '' }: LoadingStateProps) => {
  return (
    <div
      slot='menu'
      data-test='loading-state-component'
      className={clsx('_d-flex _flex-column _align-items-center _px-8', className)}>
      <Loader />
    </div>
  )
}

export default LoadingState
